<template>
  <div
    id="upcoming-events"
    class="container-fluid"
    v-if="loggedInUser">
    <!-- Page Header -->
    <div class="row border-bottom border-muted py-3">
      <div class="
        col
        d-flex
        flex-column
        flex-lg-row
        align-items-center
      ">
        <h3 class="mb-3 m-lg-0">
          Upcoming Events
        </h3>
      </div>
    </div>
    <!-- / Page Header -->

    <!-- Registrations -->
    <div class="mt-3">
      <div
        v-for="registration in upcomingRegistrations"
        :key="registration.id">
        <div class="d-flex flex-column flex-lg-row align-items-lg-center">
          <!-- Registrant & Event -->
          <RegistrantAndEvent
            class="col text-lg-left text-center"
            :registration="registration"
          />
          <!-- / Registrant & Event -->

          <!-- Payment Summary -->
          <div class="col mt-3 mt-lg-0 text-right">
            <div
              class="d-flex justify-content-center justify-content-lg-end">
              <div class="text-highlight mr-3">
                <div>Files Uploaded:</div>
              </div>
              <div>
                <div>
                  {{registration.count_files}}
                </div>
              </div>
            </div>

            <b-form-file
              id="attach-new-file"
              ref="attachNewFile"
              name="attachNewFile"
              class="text-left mr-lg-0 ml-lg-auto mx-auto d-block mt-3"
              v-model="attachments"
              placeholder="Click to upload multiple files..."
              @input="uploadFiles(registration.id)"
              :readonly="submitting"
              multiple>
            </b-form-file>

            <div
              v-if="recentUploads[registration.id]"
              class="mt-3 font-italic text-left">
              <b>Recently Uploaded:</b>
              {{recentUploads[registration.id].join(', ')}}
            </div>
          </div>
          <!-- / Payment Summary -->
        </div>
        <hr>
      </div>
    </div>
    <!-- / Registrations -->

    <!-- No Events Indicator -->
    <div
      id="no-events"
      class="d-flex flex-column justify-content-center text-center p-3 font-italic"
      v-if="upcomingRegistrations.length === 0">
      You have no upcoming events.
    </div>
    <!-- / No Events Indicator -->
  </div>
</template>

<script>
import _ from 'lodash';
import AppMixin from '../services/mixin.app';
import DataSvc from '../services/data';

export default {
  name: 'upcoming-events',
  mixins: [
    AppMixin,
  ],
  data() {
    return {
      submitting: false,
      attachments: [],
      recentUploads: {},
    };
  },
  methods: {
    uploadFiles(registrationID) {
      if (this.attachments.length === 0) return;

      const fileUploadPromises = [];

      this.submitting = true;
      this.showGlobalLoader('Uploading file(s)...');

      _.each(this.attachments, (file) => {
        const data = new FormData();

        data.append('file', file);
        data.append('registration_id', registrationID);

        fileUploadPromises.push(DataSvc.uploadRegistrationFile(data));
      });

      // eslint-disable-next-line
      return Promise.all(fileUploadPromises)
        .then((files) => {
          const newFiles = _.map(files, 'filename');

          if (this.recentUploads[registrationID]) {
            this.recentUploads[registrationID] = newFiles.concat(this.recentUploads[registrationID]);
          } else {
            this.recentUploads[registrationID] = newFiles;
          }
        })
        .then(this.updateClosedRegistrationSessions)
        .finally(() => {
          this.attachments = [];
          this.submitting = false;
          this.hideGlobalLoader();
        });
    },
  },
};
</script>

<style lang="scss">
#upcoming-events {
  .custom-file-label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}
</style>
